/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AgentCallPersonality } from './AgentCallPersonality';
import type { ContactInfo } from './ContactInfo';
import type { Dictionary_unknown_ } from './Dictionary_unknown_';
import type { EmployeePersonalityLocalization } from './EmployeePersonalityLocalization';
import type { VapiProviderConfig } from './VapiProviderConfig';
/**
 * Interface representing Vapi agent call creation parameters
 */
export type VapiAgentCallCreateBodyParams = {
    toPhoneNumber: string;
    fromPhoneNumber?: string;
    objectives: Array<string>;
    userId?: number;
    personality?: AgentCallPersonality;
    localization?: EmployeePersonalityLocalization;
    constraints?: Array<string>;
    contactInfo?: ContactInfo;
    knowledgeBase?: string;
    taskSteps?: Array<string>;
    maxDurationSeconds?: number;
    silenceTimeoutSeconds?: number;
    customData?: Dictionary_unknown_;
    provider?: VapiAgentCallCreateBodyParams.provider;
    providerConfig?: VapiProviderConfig;
};
export namespace VapiAgentCallCreateBodyParams {
    export enum provider {
        VAPI = 'vapi',
    }
}

